import { Button } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const HeaderWrapperStyled = styled.div`
  position: relative;
`;

export const BackButtonStyled = styled(Button)`
  position: absolute;
  left: 0;
  top: 34%;
`;

export const TitleStyled = styled.h1`
  margin: 1.2rem 0 0.8rem;
  font-size: 2.4rem;
  line-height: 3.2rem;
  font-weight: 700;
  letter-spacing: 0.02rem;
`;

export const CaptionStyled = styled.p`
  margin-bottom: 1.2rem;
  font-size: 1.8rem;
  line-height: 2.8rem;
  letter-spacing: 0.02rem;
  padding: 0 10%;
  max-width: 50rem;
`;

export const TitleWrapperStyled = styled.div`
  margin: 5.6rem auto 6rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SpinnerWrapperStyled = styled.div`
  position: relative;
  width: 5rem;
  height: 5rem;
  margin: 0 auto;
`;
